import { a11yAria } from '../../../TypeScript/Utilities/AriaUtilities';
var closeAllSubItems = function (Event, mobileNavigation) {
    var currentTarget = Event.currentTarget;
    var subItems = Array.from(mobileNavigation.querySelectorAll('[data-toggle-navigation-button][aria-expanded="true"]'));
    subItems.map(function (item) { return currentTarget !== item && item.click(); });
};
var subNavigationTriggerEvent = function (trigger, mainItem) {
    var subItem = mainItem.querySelector('ul');
    subItem.classList.toggle('hidden');
    subItem.setAttribute('aria-hidden', a11yAria.toggle.hidden(subItem));
    trigger.setAttribute('aria-expanded', a11yAria.toggle.expanded(trigger));
    trigger.setAttribute('aria-label', a11yAria.toggle.label(trigger, trigger.dataset.ariaLabel, trigger.dataset.ariaLabelOnChange));
    trigger.classList.toggle('rotate-180');
};
var getNavigationItems = function (mainItem, mobileNavigation) {
    var triggers = Array.from(mainItem.querySelectorAll('[data-toggle-navigation-button]'));
    var fakeTriggers = Array.from(mainItem.querySelectorAll('[data-open-subnavigation]'));
    triggers.map(function (trigger) {
        fakeTriggers.map(function (ft) { return ft.addEventListener('click', function () { return ft.parentElement.querySelector('[data-toggle-navigation-button]').click(); }); });
        trigger.addEventListener('click', function (Event) { return closeAllSubItems(Event, mobileNavigation); });
        trigger.addEventListener('click', function () { return subNavigationTriggerEvent(trigger, mainItem); });
    });
};
export var SubNavigationHandler = function (mainItem, mobileNavigation) { return getNavigationItems(mainItem, mobileNavigation); };
